import React from "react";
import NewHero from "../../components/newhero/NewHero";
import CircularCards from "../../components/circularCards/CircularCards";
// import WhatIsDevfest from "../../components/whatIsDevfest/WhatIsDevfest";
import Technology from "../../components/technologies/Technology";
import FAQs from "../../components/FAQs/FAQs";
import GetToKnow from "../../components/get_to_know_us/GetToKnow";
// import { Schedule } from "../../components/schedule/Schedule";
// import Slider from "../../components/slider/Slider";
// import TwitterFeed from "../../components/twitterFeed/TwitterFeed";

const Home = () => {
  return (
    <div className={"layout-content"}>
      {" "}
      <NewHero></NewHero>
      {/* <WhatIsDevfest></WhatIsDevfest> */}
      {/* <Slider></Slider> */}
      <GetToKnow />
      <CircularCards></CircularCards>
      <Technology></Technology>
      {/* <Schedule></Schedule> */}
      {/* <TwitterFeed></TwitterFeed> */}
      <FAQs></FAQs>
    </div>
  );
};

export default Home;
